import {
    Component,
    ComponentFactory,
    ComponentFactoryResolver,
    ComponentRef,
    Input,
    OnInit,
    Type,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { FieldService } from '../../services/field.service';
import { Element } from '../../interfaces/form-structure-interfaces';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'chassis-core-element',
    templateUrl: './element.component.html',
    styleUrls: ['./element.component.scss']
})
export class ElementComponent implements OnInit {
    @Input() entity: any;

    @Input() static: false;

    @Input() element: Element;

    @Input() control: FormControl;

    /**
     * The ViewContainerRef instance.
     */
    @ViewChild('content', {read: ViewContainerRef}) content: ViewContainerRef;

    constructor(
        protected fieldService: FieldService,
        protected componentFactoryResolver: ComponentFactoryResolver,
    ) {
    }

    ngOnInit() {
        if (this.element) {
            const component = this.getComponent();

            // Cancel when no filter component is registered.
            if (!component) {
                return;
            }

            const componentFactory = this.createComponentFactory(
                component
            );

            const componentRef = this.createComponentRef(
                componentFactory,
            );

            const instance = componentRef.instance;

            this.bindProperties(instance);
        }
    }

    protected getComponent(): Type<any> | null {
        let type: 'input' | 'detail' | 'datatable' = 'input';

        if (this.static) {
            type = 'detail';
        }

        return this.fieldService.get(
            this.element.component,
            type
        );
    }

    protected createComponentFactory(component: Type<any>): ComponentFactory<any> {
        return this.componentFactoryResolver.resolveComponentFactory(
            component,
        )
    }

    protected createComponentRef(factory: ComponentFactory<any>): ComponentRef<any> {
        return this.content.createComponent(
            factory,
        )
    }

    protected bindProperties(instance: Component): void {
        instance['data']    = this.element;
        instance['control'] = this.control;
        instance['entity']  = this.entity;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/resources/components/element/element.component.ts